import React  from "react";
import TimeCardTable from "./components/TimeCardTable";
import { connect } from "react-redux";

const TimeCard = () => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">      		
	      	<TimeCardTable/>
	      	
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeCard);